import { render, staticRenderFns } from "./EditExpenseModal.vue?vue&type=template&id=5cbc9ddc&scoped=true&class=fill-height&"
import script from "./EditExpenseModal.vue?vue&type=script&lang=ts&"
export * from "./EditExpenseModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditExpenseModal.vue?vue&type=style&index=0&id=5cbc9ddc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbc9ddc",
  null
  
)

export default component.exports